export default __webpack_public_path__ + "static/skills-10a35d6fc1bc6a3057286b6b5c4aa10a.png";